import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

export interface HamburgerItem {
	headerLabel: string;
	headerValue: any;
	headerIcon?: string;
	options: HamburgerOption[];
}

export interface HamburgerOption {
	label: string;
	value: any;
	active: boolean;
	onSelected?: (option: HamburgerOption, ev: MouseEvent) => void;
	disabled?: boolean;
}

export interface HamburgerOptionSelected {
	headerValue: any;
	value: any;
}

@Component({
	selector: 'bb-hamburger-overlay',
	templateUrl: './bb-hamburger-overlay.component.html',
	styleUrls: ['./bb-hamburger-overlay.component.scss']
})

export class BbHamburgerOverlayComponent implements OnInit {
	@Input() options: HamburgerItem[];
	@Output() optionSelected: EventEmitter<HamburgerOptionSelected> = new EventEmitter<HamburgerOptionSelected>();

	isOpen = false;
	private forcedClose = false;

	constructor() {
	}

	ngOnInit() { }

	public open(): void {
		if (!this.forcedClose) {
			this.isOpen = !this.isOpen;
		}
	}

	public close(): void {
		this.isOpen = false;
	}

	public optionSelect(item: HamburgerItem, option: HamburgerOption, ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		if (option && typeof option.onSelected === 'function') {
			option.onSelected(option, ev);
		}
		const result = {
			headerValue: item.headerValue,
			value: option.value
		};
		this.optionSelected.emit(result);
		this.close();
	}

	public outsideClick(): void {
		// outsideClick is triggered before open() triggered outside this element
		// Make sture that an external (click)-element can toggle open by using this.forcedClose
		if (this.isOpen) {
			this.forcedClose = true;
			setTimeout(() => {
				this.forcedClose = false;
			});
		}
		this.close();
	}
}
